import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { motion, useReducedMotion } from 'framer-motion';
import './FreeDemoSection.css';

const FreeDemoSection = () => {
  const reduceMotion = useReducedMotion();
  const reveal = reduceMotion
    ? {}
    : {
        initial: { opacity: 0, y: 24 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.55 },
        viewport: { once: true, margin: '-60px' },
      };

  const whatsappUrl = `https://api.whatsapp.com/send/?phone=${process.env.REACT_APP_MOBILE_NUMBER1}&text=${encodeURIComponent(
    "Hi! I'd like to book a FREE trial class for my child."
  )}&type=phone_number&app_absent=0`;

  return (
    <section className="rmcta" aria-labelledby="rmcta-title">
      <div className="rmcta-inner">
        <motion.div className="rmcta-card" {...reveal}>
          <div className="rmcta-copy">
            <h2 id="rmcta-title" className="rmcta-title">
              Start with a <span>free class</span> this week
            </h2>
            <p className="rmcta-text">
              Tell us your child’s age and interests, and we’ll book a live 1-to-1 trial with an instructor at a
              time that suits you.
            </p>
            <ul className="rmcta-points">
              <li>
                <FontAwesomeIcon icon={faCheck} /> No obligation
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} /> Personalized to your child
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} /> Leave with a first project
              </li>
            </ul>
          </div>

          <div className="rmcta-actions">
            <Link to="/FreeTrial" className="rmcta-btn rmcta-btn-primary">
              Book a Free Trial Class
              <FontAwesomeIcon icon={faArrowRight} />
            </Link>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="rmcta-btn rmcta-btn-ghost">
              <FontAwesomeIcon icon={faWhatsapp} className="rmcta-wa" />
              Book on WhatsApp
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FreeDemoSection;